(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/theme-days/assets/javascripts/temadagar.js') >= 0) return;  svs.modules.push('/components/tur/theme-days/assets/javascripts/temadagar.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

svs.tur = svs.tur || {};
svs.tur.theme_days = svs.tur.theme_days || {};
let themeDaysByDate = {};
if (svs.isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  svs.tur.theme_days.logger = svs.tur.theme_days.logger || trinidad.logger('tur:theme-days');
  themeDaysByDate = require('../theme-days-generator/out/temadagar.json').themeDaysByDate;
} else {
  svs.tur.theme_days.logger = svs.tur.theme_days.logger || svs.core.log.getLogger('tur:theme-days');
  themeDaysByDate = svs.tur.theme_days.data.themeDaysConfig.themeDaysByDate;
}
const isLeapYear = year => new Date(year, 1, 29).getDate() === 29;
const isLeapYearAffectingDate = date => date.getMonth() === 1 && date.getDate() > 27;
const formatDate = date => "".concat(date.getMonth() + 1, "-").concat(date.getDate());
const isLastDayOfMonthRule = week => week < 0;
const isEqualOrGreaterThan = function (themeDate) {
  let currentDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date(Date.now());
  themeDate.setHours(23, 59, 0, 0);
  return themeDate > currentDate;
};

const getDateByWeekAndWeekday = (year, month, week, day) => {
  const firstDay = 1;
  const date = new Date(year, month, week * 7 + firstDay, 12);
  if (date.getDay() === day) {
    return isEqualOrGreaterThan(date) ? date : getDateByWeekAndWeekday(year + 1, month, week, day);
  }
  let dateDay = day;
  if (date.getDay() >= dateDay) {
    dateDay += 7;
  }
  date.setDate(date.getDate() - date.getDay() + dateDay);
  return isEqualOrGreaterThan(date) ? date : getDateByWeekAndWeekday(year + 1, month, week, day);
};

const getLastWeekdayInMonth = (year, month, dayOfWeek) => {
  const date = new Date(year, month + 1, 0, 12);
  date.setDate(date.getDate() - (date.getDay() + 7 - dayOfWeek) % 7);
  return isEqualOrGreaterThan(date) ? date : getLastWeekdayInMonth(year + 1, month, dayOfWeek);
};

const calculateEaster = (year, incrementOrDecrement) => {
  const C = Math.floor(year / 100);
  const N = year - 19 * Math.floor(year / 19);
  const K = Math.floor((C - 17) / 25);
  let I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
  I = I - 30 * Math.floor(I / 30);
  I = I - Math.floor(I / 28) * (1 - Math.floor(I / 28) * Math.floor(29 / (I + 1)) * Math.floor((21 - N) / 11));
  let J = year + Math.floor(year / 4) + I + 2 - C + Math.floor(C / 4);
  J = J - 7 * Math.floor(J / 7);
  const L = I - J;
  const M = 3 + Math.floor((L + 40) / 44);
  const D = L + 28 - 31 * Math.floor(M / 4);
  const date = new Date(Date.now());
  date.setFullYear(year);
  date.setMonth(M - 1);
  date.setDate(D);
  date.setDate(date.getDate() + parseInt(incrementOrDecrement, 10));
  if (isLeapYear(year) && isLeapYearAffectingDate(date)) {
    date.setDate(date.getDate());
  }
  return isEqualOrGreaterThan(date) ? date : calculateEaster(year + 1, incrementOrDecrement);
};

const firstOfWeekdayAfterDate = (weekday, refDate) => {
  const plusDays = (d, days) => {
    const date = new Date(d);
    date.setDate(date.getDate() + (days || 0));
    return date;
  };
  return plusDays(refDate, (refDate.getDay() > weekday ? 7 : 0) - refDate.getDay() + weekday);
};

const getDate = function () {
  let rules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date(Date.now()).getFullYear();
  if (rules.includes('MIDSUMMER')) {
    return firstOfWeekdayAfterDate(5, new Date(year, 5, 19));
  }
  if (rules.includes('ALL_SAINTS_DAY')) {
    return firstOfWeekdayAfterDate(6, new Date(year, 9, 31));
  }
  if (rules.includes('EASTER')) {
    const [, incrementOrDecrement = 0] = rules;
    return calculateEaster(year, incrementOrDecrement);
  }
  const [month, week, day] = rules.map(v => parseInt(v, 10));
  if (isLastDayOfMonthRule(week)) {
    return getLastWeekdayInMonth(year, month, day);
  }
  return getDateByWeekAndWeekday(year, month, week, day);
};
const addThemedayByDate = function (themeDaysByDate, date) {
  var _themeDaysByDate$mont;
  let names = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  const [monthKey, dayKey] = date.split('-');
  if (!themeDaysByDate[monthKey]) {
    themeDaysByDate[monthKey] = {
      [dayKey]: []
    };
  }
  if (((_themeDaysByDate$mont = themeDaysByDate[monthKey][dayKey]) === null || _themeDaysByDate$mont === void 0 ? void 0 : _themeDaysByDate$mont.length) > 0) {
    themeDaysByDate[monthKey][dayKey] = themeDaysByDate[monthKey][dayKey].concat(names);
    return themeDaysByDate;
  }
  themeDaysByDate[monthKey][dayKey] = names;
  return themeDaysByDate;
};

const parseThemeDaysByDate = function () {
  let themeDaysData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : themeDaysByDate;
  return themeDaysData.ruleDates.reduce((_ref, _ref2) => {
    let {
      themeDays
    } = _ref;
    let {
      rules,
      names
    } = _ref2;
    const date = getDate(rules, new Date(Date.now()).getFullYear());
    const maxDate = new Date(Date.now());
    maxDate.setFullYear(maxDate.getFullYear() + 1);
    if (date > maxDate) {
      return {
        themeDays
      };
    }
    const formattedDate = formatDate(date);
    const trimmedNames = names.map(n => n.trim());
    return {
      themeDays: addThemedayByDate(themeDays, formattedDate, trimmedNames)
    };
  }, structuredClone(themeDaysData));
};
const calculatedThemeDays = parseThemeDaysByDate(themeDaysByDate).themeDays;
svs.tur.theme_days = _objectSpread(_objectSpread({}, svs.tur.theme_days), {}, {
  getThemeDayNames: () => Object.values(calculatedThemeDays).flatMap(days => Object.values(days)).flatMap(names => names),
  getThemeDays: () => calculatedThemeDays,
  getThemesForDay: function () {
    var _calculatedThemeDays;
    let date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date(Date.now());
    return ((_calculatedThemeDays = calculatedThemeDays[date.getMonth() + 1]) === null || _calculatedThemeDays === void 0 ? void 0 : _calculatedThemeDays[date.getDate()]) || [];
  },
  test: {
    parseThemeDaysByDate,
    getDate: (rules, year) => formatDate(getDate(rules, year))
  }
});
if (svs.isServer) {
  module.exports = svs.tur.theme_days;
}

 })(window);